import { jsx as _jsx } from "react/jsx-runtime";
import { EuiIcon } from "@elastic/eui";
import { COLORS } from "../../common/constants";
export var SuperAdminIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? COLORS.OFFWHITE : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    return (_jsx(EuiIcon, { type: "gear", size: "l", color: fillColor, className: className }));
};
